const app = {
  title: window.$app.meta['app:title'],
  tagline: window.$app.meta['app:tagline'],
  copyright: window.$app.meta['app:copyright'],
  email: window.$app.meta['app:email'],
  year: window.$app.meta['app:year'],
  author: window.$app.meta['app:author'],
  logo: window.$app.logo,
  locale: window.$app.locale,
}

export default app
